import React, { useState, useEffect, useRef } from 'react'
import ModalEcommerce from './ModalEcommerce'
import ModalReino from './ModalReino'
import ModalEsports from './ModalEsports'
import Aos from 'aos'
import 'aos/dist/aos.css'
import Lottie from "lottie-react"
import animationCrypto from "../assets/Animationcrypto.json"
import animationCryptoChain from "../assets/crypto.json"
import animationEcomerce from "../assets/animationEcommerce.json"
import animationEcomerce2 from "../assets/animationEcommerce2.json"
import player from "../img/player.png"
import player1 from "../../src/img/lamp.png"
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import safireProduct from "../img/safireProduct.png"
import { Grid } from '@mui/material'

const Projetos = (props) => {
  const [nativeLanguage, setNativeLanguage] = useState(true)
  const [modalEcommerce, setModalEcommerce] = useState(false)
  const [modalEsports, setModalEsports] = useState(false)
  const [modalReino, setModalReino] = useState(false)
  const [more, setMore] = useState(2)
  const [show, setShow] = useState('')
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [mobile, setMobile] = useState(false);
  const containerRef = useRef(null);
  const [projetos, setProjetos] = useState([
    {
      nome: 'Coach Inefavel',
      image: 'imageContent6',
      tecnologia: ['reactIcon', 'mongoIcon', 'nextIcon', 'javascriptIcon', 'apiIcon'],
      texto: nativeLanguage
        ? "Plataforma online de venda de coach, onde você pode agendar sessões e realizar pagamentos via PIX."
        : "Online platform for selling coaching services, where you can schedule sessions and make payments via PIX.",
      codigo: 'https://github.com/hlpires/ecommercemongodb',
      demo: 'https://ecommercemongodb.vercel.app/',
      video: true,
      animation: animationEcomerce,
      images: [player, safireProduct],
      imageIndex: 0,
      usuarios: "173",
      website: "https://coachinefavel.com"
    },
    {
      nome: 'Safire',
      image: 'imageContent',
      tecnologia: ['reactIcon', 'mongoIcon', 'nextIcon', 'javascriptIcon'],
      texto: nativeLanguage ? "Loja online de vendas de produtos, com sistema de carrinho de compras, pagamentos, login, banco de dados proprio e área de admin para registro de novos produtos."
        : "Online store for the sale of products, with a shopping cart system, payment processing, login functionality, a proprietary database, and an admin area for registering new products.",
      codigo: 'https://github.com/hlpires/ecommercemongodb',
      demo: 'https://ecommercemongodb.vercel.app/',
      video: false,
      animation: animationEcomerce,
      images: [player, safireProduct],
      imageIndex: 0
    },
    {
      nome: 'Fast Crypto',
      image: 'imageContent2',
      tecnologia: ['reactIcon', 'mongoIcon', 'apiIcon', 'javascriptIcon'],
      texto: nativeLanguage ? 'Aplicação web para consulta de dados de crypto moedas, para analises de mercado utilizando gráficos.'
        : "Web application for querying cryptocurrency data for market analysis using charts.",
      codigo: 'https://github.com/hlpires/fastcrypto',
      demo: 'https://fastcrypto-nu.vercel.app/',
      animation: animationCrypto,
      animationStyle: { marginLeft: "-200px", width: "78%" }
    },
    {
      nome: 'Web 3 project (Development)',
      image: 'imageContent3',
      tecnologia: ['solidityIcon', 'metamaskIcon', 'reactIcon', 'ethereumIcon'],
      texto: nativeLanguage ? 'Mercado de compra e vendas de NFTS, utlizando a rede Ethereum.'
        : "Marketplace for buying and selling NFTs using the Ethereum network.",
      codigo: '',
      demo: '',
      animation: animationCryptoChain,
      animationStyle: { width: "400px", marginLeft: "160px" }
    },
    {
      nome: 'Tecno Center',
      image: 'imageContent4',
      tecnologia: ['reactIcon', 'javascriptIcon', 'apiIcon', ''],
      texto: nativeLanguage ? 'Comercio online que utiliza uma api para fazer o banco de dados, sistema de pagamentos.'
        : "Online commerce that utilizes an API to manage the database and payment system.",
      codigo: 'https://github.com/hlpires/ecommercemongodb',
      demo: 'https://ecommerceapp-self.vercel.app/',
      animation: animationEcomerce2,
      animationStyle: { marginLeft: "-120px", width: "70%" }
    }
    // {
    //   nome: 'Reino Animal',
    //   image: 'imageContent5',
    //   tecnologia: ['javascriptIcon', '', '', ''],
    //   texto: 'Aplicação Web, para promoção e divulgação de serviços de uma Petshop de Caruaru SP',
    //   codigo: 'https://github.com/hlpires/reinoAnimalProject',
    //   demo: 'https://hlpires.github.io/reinoAnimalProject/'
    // },
  ])

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };



  useEffect(() => {
    setNativeLanguage(props.location)
  }, [props.location]);




  useEffect(() => {

    Aos.init({ duration: 1000 })

  }, [])


  const changeImageIndexPlus = (index) => {
    setProjetos(projetos.map((item, indexY) => {
      if (index === indexY) {
        return {
          ...item,
          imageIndex: item.imageIndex + 1
        };
      }
      return item;
    }))
  }

  const changeImageIndexMinus = (index) => {
    setProjetos(projetos.map((item, indexY) => {
      if (index === indexY) {
        return {
          ...item,
          imageIndex: item.imageIndex - 1
        };
      }
      return item;
    }))
  }

  useEffect(() => {
    const handleResize = (entries) => {
      for (let entry of entries) {
        const width = entry.contentRect.width;
        if (width < 1100) {
          setMobile(true);
        } else {
          setMobile(false);
        }
      }
    };

    if (containerRef.current) {
      const resizeObserver = new ResizeObserver(handleResize);
      resizeObserver.observe(containerRef.current);

      return () => {
        resizeObserver.disconnect();
      };
    }
  }, []);

  return (
    <div ref={containerRef}>
      {/* onClick = {() =>{setModalEsports(true)}} 
   () =>{setModalEcommerce(true)}
   () =>{setModalReino(true)} */}
      <div className='projetos'>
        <div className='position' style={{ position: 'relative', paddingBottom: "70px" }}>
          {/* <canvas className='fireflyShow' ref={canvasRef} style={{ position: 'absolute', width: '180px', height: '220px', top: '10px', right: '20px', zIndex: 7 }} id="canvas1"></canvas>
          <canvas className='fireflyShow' ref={canvasRef1} style={{ position: 'absolute', width: '180px', height: '23%', top: '10px', right: '20px', zIndex: 7 }} id="canvas2"></canvas>
          <img className='fireflyShow' src={lamp} style={{ position: 'absolute', right: '20px', top: '20px', width: '170px', filter: 'drop-shadow(0 20px 40px rgba(0, 0, 0, 1.1))', zIndex: 6 }} /> */}
          <div className='sobreTitle fireflyShow'><h6>{nativeLanguage ? "Projetos" : "Projects"}</h6></div>
          <Grid container style={{ marginTop: "120px" }} spacing={0}>
            {projetos.slice(0, more).map(({ nome, tecnologia, texto, codigo, demo, image, video, imageIndex, images, usuarios, website }, index) => {


              return (
                <Grid item xs={mobile ? 12 : 6}
                  style={{
                    marginTop: "0px",
                    justifyContent: "center",
                    width: "100%",
                    padding: "50px",
                    display: "flex",
                    flexDirection: index % 2 === 1 ? "row-reverse" : "row"
                  }} >
                  <div style={{ display: "flex", flexDirection: "column", width: mobile ? "120%" : "100%", position: "relative", zIndex: "8" }}>
                    <div onClick={nome === 'Coach Inefavel' ? openModal : ''}
                      style={{
                        minHeight: '480px',
                        width: "100%",
                        borderRadius: "5px"
                      }}>
                      <div style={{ position: "absolute", minHeight: '480px', width: "100%", zIndex: "4" }}>
                        <div id={image} style={{ height: '480px', borderTopLeftRadius: '15px', borderTopRightRadius: '15px', position: "relative", width: "100%" }} >
                          {video && <div
                            onMouseEnter={(e) => { e.target.style.opacity = "1" }}
                            onMouseLeave={(e) => { e.target.style.opacity = "0.6" }}
                            style={{
                              position: "absolute",
                              width: "100%",
                              height: "100%",
                              cursor: "pointer",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center"
                            }}>
                            <img style={{ width: "300px", height: "300px", opacity: "0.4" }} src={player}></img>
                          </div>}
                        </div>
                      </div>
                    </div>


                    <div className='projetosBox' id='projetosBox1'>
                      <div style={{ position: "relative", width: "100%", zIndex: 4 }}>
                        <p className='projetosTextContent'>{nome}</p>
                        {usuarios && <p className='projetosTextUsersContent'> {`Usuarios: ` + usuarios}</p>}
                        {/* {usuarios && <p className='fontJourneyX' style={{ position: "absolute", top: '40px', right: "50px", color: 'white', fontSize: '26px' }} >{`Usuarios: ` + usuarios}</p>} */}
                        <div style={{ width: '90%', height: '50px', marginLeft: '5%', display: 'flex' }}>
                          <p style={{ alignSelf: 'center', fontSize: '26px', fontFamily: 'fantasy', color: 'white' }}>{nativeLanguage ? "Tecnologia" : "Technology"}</p>
                          {tecnologia.map(((item, index) => {
                            return (
                              <div id={tecnologia[index]} style={{
                                width: '50px', height: '100%', alignSelf: 'center',
                                marginLeft: '2%'
                              }}></div>
                            )
                          }))}
                        </div>
                        <div style={{ maxHeight: '230px', overflowY: 'hidden' }}>
                          <p className='projetosTextContent2'>{texto}</p>
                        </div>
                        {website && <div style={{ width: '90%', height: '50px', marginLeft: '5%', display: 'flex', marginTop: '20px', marginBottom: '20px' }}>
                          <a href={website} target="_blank" ><div className='buttonProject'><p style={{ alignSelf: 'center' }} > {nativeLanguage ? "Site" : "Website"}</p></div></a>
                        </div>}
                        {(codigo && !website) && <div style={{ width: '90%', height: '50px', marginLeft: '5%', display: 'flex', marginTop: '20px', marginBottom: '20px' }}>
                          <a href={codigo} target="_blank" ><div className='buttonProject'><p style={{ alignSelf: 'center' }} > {nativeLanguage ? "Codigo" : "Code"}</p></div></a>
                          <a href={demo} target="_blank" style={{ marginLeft: '5%' }}><div className='buttonProject' ><p style={{ alignSelf: 'center' }} >Demo</p></div></a>
                        </div>}
                      </div>
                    </div>
                  </div>
                  {/* <div style={{ height: "100px", width: "48%", marginLeft: "140px", height: "780px", display: "flex", justifyContent: "center" }}>
                  <div style={{ alignSelf: "center", width: "800px", zIndex: "8", transform: "scaleX(1)", display: "flex", justifyContent: "center", position: "relative", height: "780px", flexDirection: "column" }}>
                    {images?.[imageIndex] && <ArrowCircleLeftIcon onClick={() => changeImageIndexMinus(index)} style={{ position: "absolute", top: "22%", left: "2%", cursor: "pointer", fontSize: "30px" }} />}
                    <img style={{ width: "600px", height: "340px", opacity: "0.4", alignSelf: "center" }} src={images?.[imageIndex]}></img>
                    <div className='bulletPointsBox' style={{ width: "600px", height: "340px", opacity: "0.4" }} src={images?.[imageIndex]}></div>
                    {images?.[imageIndex] && <ArrowCircleRightIcon onClick={() => changeImageIndexPlus(index)} style={{ position: "absolute", top: "22%", right: "2%", cursor: "pointer", fontSize: "30px" }} />}
                  </div>
                </div> */}
                </Grid>

              )
            })}
          </Grid>
          <div style={{ display: show }} onClick={
            () => {
              setMore(5)
              setShow('none')
            }
          } className='buttonExibir'>
            <p style={{ alignSelf: 'center', }}> {nativeLanguage ? "Exibir mais" : "Show more"}</p>
          </div>
        </div>
        <div className="modal1" ></div>
        <div className="modal2" style={{ zIndex: 6 }} ></div>
        {isModalOpen && (
          <div className="modal" onClick={closeModal} style={{ zIndex: 9 }}>
            <div className="modal-content">
              <span className="close" onClick={closeModal} ></span>
              <iframe width="100%" height="654" src="https://www.youtube.com/embed/lxYBYFzPwqw?si=eKx6-9xvrLUIx4GW" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
          </div>
        )}
        <ModalEcommerce open={modalEcommerce} onClose={() => setModalEcommerce(false)} />
        <ModalReino open={modalReino} onClose={() => setModalReino(false)} />
        <ModalEsports open={modalEsports} onClose={() => setModalEsports(false)} />
      </div>
    </div >
  )
}

export default Projetos